import { useMe } from '@/hooks/use-me';
import { useBusinessId } from '@/hooks/use-tenant-params';
import type { MeBusiness } from '@/lib/types';

// Connecting and disconnecting a Google Business Profile is OWNER-only
// (gbp:manage). The server is the authority for what a request may do — this
// only decides whether the control is SHOWN: a manager or editor (full or
// location-restricted) is never offered connect, reconnect or disconnect.
// It mirrors the server-side gate exactly (`requirePermission('gbp:manage')`,
// P2.3 policy row — owner only); a control shown here is one the server accepts.
//
// The role is the membership row `/api/me` returns for the Business the
// canonical route names — the same membership-derived list the switcher
// reads. Never a stored preference, never "the first business".
export function isBusinessOwner(
  businesses: readonly MeBusiness[],
  businessId: string | undefined,
): boolean {
  if (!businessId) return false;
  return businesses.some((b) => b.id === businessId && b.role === 'owner');
}

export function useCanManageGbp(): boolean {
  const businessId = useBusinessId();
  const me = useMe();
  if (me.kind !== 'ready' && me.kind !== 'no-business') return false;
  return isBusinessOwner(me.me.businesses, businessId);
}
